import { render, staticRenderFns } from "./CustomDropdown.vue?vue&type=template&id=e5b0346e&scoped=true&"
import script from "./CustomDropdown.vue?vue&type=script&lang=js&"
export * from "./CustomDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CustomDropdown.vue?vue&type=style&index=0&id=e5b0346e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b0346e",
  null
  
)

export default component.exports